const i = "Avisering", t = "Kritisk avisering", o = "Stäng meddelande", c = {
  notification: i,
  criticalNotification: t,
  close: o
};
export {
  o as close,
  t as criticalNotification,
  c as default,
  i as notification
};
